export function QBOSupportCheckContactsMatchClearCtrl ($scope, $uibModalInstance, workshopAPI, result) {

  $scope.result = result ? result : {};
}